import styled from "styled-components";

const VideoBlock = styled.div`
  background-color: ${(p) => p.theme.color.text};
  height: 100vh;
  max-width: 100vw;
  flex: 1;
  overflow: hidden;
  color: ${(p) => p.theme.color.white};
  position: relative;

  .flat-button {
    background-color: ${(p) => p.theme.color.error};
    color: ${(p) => p.theme.color.white};
    font-size: 1.1em;
    text-overflow: ellipsis;
    overflow: hidden;
    padding: 0.8em 0.5em;
    border-radius: 6px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.3);
  }
  .start-consultation {
    width: 100%;
    max-width: 240px;
    background-color: ${(p) => p.theme.color.successGreen};
  }

  /* ──── Header ──────────────────────────────────────────────────────────────────────────── */
  .header {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 1;
    max-height: 60px;
    .logo-wrapper {
      position: absolute;
      display: flex;
      align-items: center;
      height: 100%;
      left: 30px;
      svg {
        width: initial;
      }
      .azmonica {
        height: 75%;
      }
    }
    .screen-title {
      text-align: center;
      font-weight: normal;
      font-size: 1em;
      padding: 1.3em 10em;
      margin: 0;
      box-sizing: border-box;
    }
    .timer {
      position: absolute;
      right: 30px;
      top: 14px;
      font-size: 24px;
    }
  }

  /* ──── Patient details ─────────────────────────────────────────────────────────────────── */
  .patient-details {
    margin: 30vh auto;
    text-align: center;
    .image-with-default-wrapper {
      width: 120px;
      height: 120px;
    }
    .user-name {
      font-weight: normal;
      font-size: 1.85em;
      margin: 0.6em 0 0;
      .last-name {
        text-transform: uppercase;
      }
    }
    .user-status-succes {
      position: relative;
      color: ${(p) => p.theme.color.successGreen};
      margin: 0.2em;
      &:before {
        display: inline-block;
        border-radius: 50%;
        width: 0.7em;
        height: 0.7em;
        content: "";
        background-color: ${(p) => p.theme.color.successGreen};
        margin-right: 0.3em;
      }
    }
    .user-status-fails {
      position: relative;
      color: ${(p) => p.theme.color.error};
      margin: 0.2em;
      &:before {
        display: inline-block;
        border-radius: 50%;
        width: 0.7em;
        height: 0.7em;
        content: "";
        background-color: ${(p) => p.theme.color.error};
        margin-right: 0.3em;
      }
    }
    .user-waiting {
      font-size: 0.85em;
      margin: 0.5em 0 2em;
      color: ${(p) => p.theme.color.label};
    }
  }

  .participant-video-wrapper {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .participant-video-status {
    position: absolute;
    z-index: 1;
    top: 80px;
    svg {
      height: 40px;
      width: 40px;
      margin: 0 1em;
    }
    path {
      fill: ${(p) => p.theme.color.error};
    }
  }

  .participant-video {
    height: 100%;
    transform: rotateY(180deg);
  }

  /* ──── Footer ──────────────────────────────────────────────────────────────────────────── */
  .footer {
    position: absolute;
    bottom: 30px;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 0 30px;
    box-sizing: border-box;
    align-items: flex-end;

    .local-video-track {
      transform: rotateY(180deg);
      height: 120px;
      width: 180px;
      object-fit: cover;
      position: absolute;
      left: 0;
      margin-left: 4%;
    }

    .image-with-default-wrapper {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      & > img {
        height: 100%;
      }
      & > svg {
        height: 100%;
        width: 100%;
      }
    }

    .user-preview {
      min-width: 180px;
      height: 120px;
      background-color: gray;
      margin-right: 1em;
    }

    .buttons-row {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .action-button {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background-color: ${(p) => p.theme.color.background};
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 0 16px -4px rgba(0, 0, 0, 0.3);
      margin: 0 0.8em;
      &:disabled {
        pointer-events: none;
        path {
          fill: ${(p) => p.theme.color.disabled};
        }
      }
    }

    .end-call-button {
      margin-left: 1em;
      max-width: 200px;
      width: 100%;
      position: absolute;
      right: 0;
      margin-right: 4%;
    }
  }
`;

export default {
  VideoBlock,
};
